module.exports = __webpack_public_path__ + "img/smile.65142fbd.svg";